import type {ReactElement} from 'react';
import {PublishingOptionListItem} from '@Panels/poster-publishing-options-panel/components/publishing-option-list-item/publishing-option-list-item';
import type {PublishingOptions} from '@Panels/poster-publishing-options-panel/components/publishing-options-default-list/publishing-options-default-list.types';
import {EmailCampaignPublishOptionsPanelSize} from '@Panels/email-campaign-publish-options-panel/email-campaign-publish-options-panel.types';
import styles from './email-campaign-publish-options-menu-panel.module.scss';

export interface EmailCampaignPublishOptionsMenuPanelProps {
  publishingOptions: PublishingOptions[];
  size?: EmailCampaignPublishOptionsPanelSize;
  className?: string;
}

export function EmailCampaignPublishOptionsMenuPanel({
  publishingOptions,
  size = EmailCampaignPublishOptionsPanelSize.MEDIUM,
  className = '',
}: EmailCampaignPublishOptionsMenuPanelProps): ReactElement<any> {
  const getClassNamebySize = (): string => {
    if (size === EmailCampaignPublishOptionsPanelSize.SMALL) {
      return styles.small;
    }

    return styles.medium;
  };

  return (
    <div className={`${styles.mainMenuOptionsContainer} ${getClassNamebySize()} ${className}`}>
      {publishingOptions.map((option) => {
        return (
          <PublishingOptionListItem
            className={`${styles.listItem}`}
            key={option.id}
            customThumbnailClasses={option.customThumbnailClasses}
            iconName={option.iconName}
            heading={option.heading}
            subheading={option.subheading}
            thumbNailType={option.thumbNailType}
            imgSrc={option.imgSrc}
            onClick={() => {
              if (option.onClick) {
                option.onClick();
              }
            }}
          />
        );
      })}
    </div>
  );
}
